import dayjs from 'dayjs'

export const getFormattedDate = (
  dateTimeString: string,
  options?: Intl.DateTimeFormatOptions
) => {
  return new Date(dateTimeString).toLocaleDateString(navigator.language, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    ...options
  })
}

export const getFormattedDateWithTime = (dateTimeString: string | number) => {
  return new Date(dateTimeString).toLocaleDateString(navigator.language, {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  })
}

export const getDayOfWeekName = (
  day: number,
  format?: 'short' | 'long' | 'narrow'
) => {
  return new Intl.DateTimeFormat(navigator.language, {
    weekday: format || 'long'
  }).format(new Date(1970, 0, 4 + day)) // Jan 4, 1970 was a Sunday, so 4 + dayNumber aligns to Monday as 1
}

export const getBrowserTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
}

export const getEndOfDayRange = (start: Date, end: Date) => {
  const startDate = dayjs(start).startOf('day').toDate()
  const endDate = dayjs(end).endOf('day').toDate()

  return [startDate, endDate]
}

export const getRelativeTimeFromNow = (value: string | number) => {
  return dayjs(value).fromNow()
}

// Usage: formatDuration(dayjs(end).diff(dayjs(start)))
export const formatDuration = (ms: number) => {
  const dur = dayjs.duration(ms)

  if (ms < 1000) return `${dur.milliseconds()}ms`
  if (ms < 60_000)
    return `${dur.seconds()}.${Math.floor(dur.milliseconds() / 100)}s`
  return `${dur.minutes()}m ${dur.seconds()}s`
}
